import { URLS } from 'Douleutaras/constants/urls';

export const isLoginPage = (): boolean => {
  const path = window.location.pathname;

  return path.includes(URLS.AUTHENTICATION.LOGIN);
};
